<template>
  <div class="col-sm-12 nopads">
    <div class="search-form px-2 my-2">
      <div class="col-sm-12 search-form-title">
        <font-awesome-icon icon="search" />
        {{ $t('common.search') }}
      </div>
      <div class="row">
        <div class="col-sm-6">
          <span class="search-title">
            {{ $t('ins_report.from_date') }}
          </span>
          <date-time-picker
            v-model:date="fromDate"
            class="routa-input"
            format="dd.MM.yyyy HH:mm"
            :enableTimePicker="true"
            :placeholder="$t('observations_videos.search_input_format')"
          />
        </div>

        <div class="col-sm-6">
          <span class="search-title">
            {{ $t('ins_report.to_date') }}
          </span>
          <date-time-picker
            v-model:date="toDate"
            class="routa-input"
            format="dd.MM.yyyy HH:mm"
            :enableTimePicker="true"
            :placeholder="$t('observations_videos.search_input_format')"
          />
        </div>
      </div>
      <div class="row">
          <div class="col-sm-6">
              <open-contract-filter
                  ref="contracts"
                  :to="toDate"
                  :from="fromDate"
                  :show-company="false"
                  :showOnlyMyContractsOption="true"
                  :show-title="true"
                  @loading="loading = true"
                  @loadingCompleted="loading = false"
                  @contractSelected="setContract"/>
          </div>
      </div>
      <div class="row">
        <div class="col-sm-3">
          <span class="search-title">{{ $t('trip_list.search_with_road_num') }}</span>
            <input
                id="roadInput"
                v-model="roadNumber"
                type="number"
                class="form-control form-control-sm no-margin"
                :placeholder="$t('trip_list.search_with_road_num')"
            />
        </div>
        <div class="col-sm-3">
          <span class="search-title">{{ $t('map.road_section') }}</span>
            <input
                id="roadInput"
                v-model="roadSection"
                type="number"
                class="form-control form-control-sm no-margin"
                :placeholder="$t('map.road_section')"
            />
        </div>
        <div class="col-sm-3">
              <span class="search-title">{{ $t('map.distance_start')  }}</span>
              <input
                  id="distance-from"
                  v-model="distanceFrom"
                  type="number"
                  min="0"
                  step="1"
                  class="form-control form-control-sm"
              />
        </div>
        <div class="col-sm-3">
            <span class="search-title">{{ $t('map.distance_end')  }}</span>
            <input
                id="distance-from"
                v-model="distanceTo"
                type="number"
                min="0"
                step="1"
                class="form-control form-control-sm"
            />
        </div>
      </div>
      <div class="col-sm-12 button-container">
        <button
          class="btn btn-danger form-button"
          @click="onReset"
        >
          {{ $t('ins_report.clear') }}
        </button>
          <button
              class="btn btn-primary form-button"
              :disabled="!roadNumber && !roadSection"
              @click="onSubmit"
          >
              {{ $t('ins_report.search') }}
          </button>
      </div>
    </div>
    <div
      v-if="loading"
      id="loader"
      class="spinner"
    />
  </div>
</template>

<script>
import {timeUtils} from '../../mixins/TimeUtils'
import DateTimePicker from "@/components/common/DateTimePicker";
import OpenContractFilter from "../../contract/OpenContractFilter.vue";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

export default {
    name: 'RoadReportSearch',
    components: {FontAwesomeIcon, OpenContractFilter, DateTimePicker },
    mixins: [timeUtils],
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            fromDate: '',
            toDate: '',
            roadNumber: '',
            roadSection: '',
            distanceFrom: null,
            distanceTo: null,
            contract: null,
            loading: false
        }
    },

    mounted: function () {
        this.fromDate = this.getMonthStart()
        this.toDate = new Date().toISOString()
    },

    methods: {

        onReset: function () {
            this.roadNumber = ''
            this.roadName = ''
            this.fromDate = ''
            this.toDate = ''
            this.contract = null
            this.$refs.contracts.reset()
        },

        setContract: function (contract) {
            this.contract = contract
        },

        onSubmit: function () {
            var params = {}
            params.roadNum = this.roadNumber
            params.secNum = this.roadSection
            params.from = this.fromDate
            params.contract = this.contract.id
            params.to = this.toDate
            params.fromDist = this.distanceFrom
            params.toDist = this.distanceTo
            this.$emit('search', params)
        }
    }
}
</script>

<style scoped>
</style>
